module.exports = __webpack_public_path__ + "img/Darkxls.8f0f7f17.svg";